var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInboundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 35C9 37.7614 11.2386 40 14 40C16.7614 40 19 37.7614 19 35C19 32.2386 16.7614 30 14 30C11.2386 30 9 32.2386 9 35Z",
    stroke: "#525E9D",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 35C29 37.7614 31.2386 40 34 40C36.7614 40 39 37.7614 39 35C39 32.2386 36.7614 30 34 30C31.2386 30 29 32.2386 29 35Z",
    stroke: "#525E9D",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 35H29M9 35H7.4736C7.0338 35 6.8138 35 6.629 34.977C5.2662 34.8072 4.1928 33.7338 4.023 32.371C4 32.1862 4 31.9662 4 31.5264V26C4 18.8203 9.8202 13 17 13M18 31V14C18 11.1716 18 9.75736 18.8786 8.87868C19.7574 8 21.1716 8 24 8H38C40.8284 8 42.2426 8 43.1213 8.87868C44 9.75736 44 11.1716 44 14V30C44 31.8692 44 32.8038 43.5981 33.5C43.3348 33.956 42.9561 34.3348 42.5 34.598C41.8038 35 40.8692 35 39 35",
    stroke: "#525E9D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboundIcon);
export default __webpack_public_path__ + "static/media/InboundIcon.db506e01a3c099af2ba118a584481b87.svg";
export { ForwardRef as ReactComponent };